import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinmaval() {



  const cardData =
  {
    keyword: 'Cab Service in Maval',
    heading: 'Sanavi Travels: Cab Service in Maval',
    headingDescription: 'Sanavi Travels offers reliable Cab Service in Maval, providing safe, comfortable, and convenient transportation for local travel, sightseeing trips, outstation journeys, and corporate visits across the Maval region. Our fleet of well-maintained hatchbacks, sedans, SUVs, and luxury cabs ensures smooth rides, air-conditioning, and ample luggage space for a hassle-free travel experience. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free service. We provide doorstep pickup and drop services across Maval, Lonavala, Khandala, Talegaon, and nearby Pune areas, making it ideal for tourist travel, family outings, business trips, and religious visits. Choose Sanavi Travels for trusted cab services in Maval, delivering comfort, safety, and a seamless travel experience every time.',

    top: 'Top Places to Visit in Maval with Sanavi Travels',


"topPlaces": [
  {
    "title": "Maval Region (Maval Taluka)",
    "description": "Maval is a scenic and historically rich region located in the Sahyadri mountain range near Pune, forming a natural gateway between Pune and Mumbai. Known for its lush valleys, rolling hills, and dense monsoon greenery, Maval played a crucial role during the Maratha era as a strategic corridor used by Chhatrapati Shivaji Maharaj. The region is blessed with pleasant weather throughout the year and becomes exceptionally beautiful during the monsoon season when waterfalls, streams, and mist-covered hills transform the landscape into a green paradise."
  },
  {
    "title": "Lohagad Fort",
    "description": "Lohagad Fort is one of the most famous hill forts in the Maval region and a significant stronghold of the Maratha Empire. Used by Chhatrapati Shivaji Maharaj to store treasures, the fort is known for its strong fortifications, wide plateaus, and the iconic Vinchu Kata (Scorpion’s Tail) structure. The trek to Lohagad is easy yet rewarding, making it popular among families, beginners, and history enthusiasts. During monsoon, the fort is surrounded by clouds and lush greenery, offering breathtaking views."
  },
  {
    "title": "Visapur Fort",
    "description": "Visapur Fort, located near Lohagad, is a massive hill fort built during the early Peshwa period. Taller and larger than Lohagad, it offers panoramic views of the entire Maval valley. The fort is known for its ruins, large stone structures, old water tanks, and historical caves. Trekking to Visapur during the rainy season is an adventurous experience due to waterfalls flowing along the route and the fort walls."
  },
  {
    "title": "Pavana Dam and Pavana Lake",
    "description": "Pavana Dam and its vast lake are among the most serene attractions in the Maval region. Surrounded by hills and open grasslands, the lake offers stunning sunset views and a peaceful atmosphere. It is a popular destination for camping, photography, and lakeside picnics. The calm waters combined with starry night skies make Pavana Lake a favorite weekend escape for travelers from Pune and Mumbai."
  },
  {
    "title": "Tikona Fort",
    "description": "Tikona Fort, also known as Vitandgad, stands out due to its distinctive triangular shape. Located near Pavana Lake, this fort offers a moderately challenging trek and rewards visitors with breathtaking views of surrounding forts, valleys, and water bodies. Historically, Tikona Fort was an important watchtower controlling trade routes in the Maval region. The fort’s gates, caves, and water tanks reflect Maratha military architecture."
  },
  {
    "title": "Rajmachi Fort",
    "description": "Rajmachi Fort is a historic twin-fort complex consisting of Shrivardhan and Manaranjan forts, nestled deep within the Maval hills. It played a key role in controlling the Bor Ghat trade route during the Maratha period. Rajmachi is famous for its long scenic trek, firefly sightings before monsoon, and lush greenery during rains. The fort offers a perfect blend of adventure, history, and natural beauty."
  },
  {
    "title": "Karla and Bhaja Caves",
    "description": "The ancient Karla and Bhaja Caves are rock-cut Buddhist monuments dating back over 2,000 years. Located in the Maval region, these caves feature grand chaitya halls, intricately carved pillars, and prayer spaces used by monks. The Karla Chaitya is one of the largest and best-preserved Buddhist prayer halls in India, showcasing exceptional ancient craftsmanship and spiritual heritage."
  },
  {
    "title": "Bedse Caves",
    "description": "Bedse Caves are lesser-known yet beautiful rock-cut Buddhist caves located amidst quiet hills of Maval. Reached via a short trek through villages and greenery, these caves offer peace, scenic views, and historical significance. Their calm surroundings make them ideal for travelers seeking solitude and offbeat heritage experiences."
  },
  {
    "title": "Tung Fort",
    "description": "Tung Fort, rising steeply from the Pavana Lake area, is a compact yet dramatic hill fort. The trek to Tung is short but steep, making it popular among adventure seekers. The fort provides spectacular panoramic views of Pavana Lake, Tikona, and Lohagad forts. Historically, Tung Fort served as a strategic lookout point during the Maratha era."
  },
  {
    "title": "Maval Villages and Rural Culture",
    "description": "The villages of Maval reflect authentic rural Maharashtrian life, with farming landscapes, traditional houses, and local cuisine. Visitors can experience warm hospitality, regional food, and simple living amidst nature. The region’s rural charm, combined with its historical and natural richness, makes Maval a perfect destination for cultural and eco-tourism."
  }
]
,



"services": [
{
"name": "Cabs Service in Maval",
"description": "Cabs Service in Maval provides reliable, safe, and comfortable taxi services for local commuting, sightseeing, and outstation trips. With well-maintained vehicles, professional drivers, and timely service, it ensures smooth travel experiences for residents, tourists, families, and corporate travelers exploring Maval and nearby destinations. Ideal for day trips, business travel, and leisure journeys, this service emphasizes convenience, punctuality, and customer satisfaction."
},
{
"name": "Taxi Service Maval",
"description": "Taxi Service Maval offers professional and hassle-free cab solutions for short-distance rides, city travel, and planned excursions. With courteous drivers, transparent pricing, and flexible booking options, it is a preferred choice for residents, tourists, and business travelers looking for reliable local transportation across Maval and surrounding areas."
},
{
"name": "AC Cab Maval",
"description": "AC Cab Maval ensures a comfortable and cool travel experience with fully air-conditioned vehicles. Ideal for long-distance trips, weekend getaways, family outings, and business travel, these cabs provide smooth rides, relaxing interiors, and a premium travel experience for all passengers."
},
{
"name": "Local Cab Maval",
"description": "Local Cab Maval provides quick, convenient, and affordable taxi services for city commuting, shopping trips, and local sightseeing. With professional drivers and prompt service, it offers a reliable solution for residents and visitors needing short-distance travel within Maval."
},
{
"name": "Outstation Cab Maval",
"description": "Outstation Cab Maval specializes in long-distance taxi services to nearby cities, tourist spots, and hill stations. Comfortable vehicles, skilled drivers, and flexible itineraries ensure a safe, convenient, and enjoyable journey for families, groups, and solo travelers exploring destinations beyond Maval."
},
{
"name": "Affordable Cab Maval",
"description": "Affordable Cab Maval delivers budget-friendly taxi services without compromising on comfort or safety. Perfect for daily commuters, families, and group travelers, it combines economical pricing with dependable vehicles and professional drivers, making it a smart choice for cost-conscious passengers."
},
{
"name": "Chauffeur Driven Cab Maval",
"description": "Chauffeur Driven Cab Maval provides trained and professional drivers who handle routes, traffic, and navigation, allowing passengers to relax throughout the journey. Ideal for business travel, VIP trips, and family outings, this service ensures a stress-free, smooth, and enjoyable travel experience."
},
{
"name": "Best Cab Service Maval",
"description": "Best Cab Service Maval is known for punctual pickups, clean and well-maintained vehicles, and a customer-focused approach. Suitable for local travel, sightseeing, airport transfers, and outstation trips, it guarantees safe, comfortable, and reliable taxi services every time."
},
{
"name": "Tourist Cab Maval",
"description": "Tourist Cab Maval caters to travelers exploring Maval and nearby attractions. With flexible itineraries, knowledgeable drivers, and comfortable vehicles, it provides a memorable sightseeing experience, allowing tourists to enjoy scenic spots, forts, and nature trips without worrying about logistics or navigation."
},
{
"name": "Picnic Cab Maval",
"description": "Picnic Cab Maval is perfect for family picnics, group outings, and leisure trips around Maval. Spacious and comfortable cabs, along with reliable drivers, ensure that groups can travel safely, relax during the journey, and enjoy a hassle-free picnic experience to nearby scenic locations."
},
{
"name": "Weekend Trip Cab Maval",
"description": "Weekend Trip Cab Maval offers convenient taxi services for short getaways and weekend excursions from Maval. Designed for families, friends, and couples, it provides comfortable vehicles, flexible scheduling, and dependable drivers to make weekend trips relaxing, enjoyable, and well-organized."
},
{
"name": "Online Cab Booking Maval",
"description": "Online Cab Booking Maval allows travelers to reserve cabs quickly and easily with instant confirmation. Multiple vehicle options, transparent pricing, and flexible scheduling make planning trips efficient, hassle-free, and convenient for tourists, corporate clients, and local commuters alike."
},
{
"name": "Family Cab Maval",
"description": "Family Cab Maval provides spacious, safe, and comfortable vehicles suitable for family travel. Designed to accommodate all age groups, it ensures a smooth and enjoyable journey for family outings, vacations, and day trips within Maval and nearby areas."
},
{
"name": "Corporate Cab Maval",
"description": "Corporate Cab Maval offers professional taxi services for executives, office travel, meetings, and corporate events. With punctual pickups, experienced drivers, and well-maintained vehicles, it ensures efficient, reliable, and stress-free transportation for business purposes."
},
{
"name": "Maval Travel Taxi",
"description": "Maval Travel Taxi provides complete taxi solutions for local commuting, tourist travel, and outstation trips. Combining comfort, safety, affordability, and professional service, it caters to residents, tourists, families, and corporate travelers seeking dependable and convenient transportation in Maval."
}
],
"tableData": [
["Cabs Service in Maval", "Taxi Service Maval"],
["AC Cab Maval", "Local Cab Maval"],
["Outstation Cab Maval", "Affordable Cab Maval"],
["Chauffeur Driven Cab Maval", "Best Cab Service Maval"],
["Tourist Cab Maval", "Picnic Cab Maval"],
["Weekend Trip Cab Maval", "Online Cab Booking Maval"],
["Family Cab Maval", "Corporate Cab Maval"],
["Maval Travel Taxi", "—"]
]
,



"whychoose": [
  {
    "WhyChooseheading": "Cab Service in Maval with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels offers reliable and comfortable cab services in Maval for local travel, airport transfers, sightseeing, and outstation trips."
  },
  {
    "WhyChooseheading": "Clean and Well-Maintained Cabs",
    "WhyChoosedescription": "Our cabs are regularly serviced, air-conditioned, and kept clean to ensure a smooth and enjoyable ride around Maval."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are licensed, courteous, and familiar with Maval routes, ensuring safe, timely, and pleasant travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels provides clear and upfront pricing for all cab services in Maval, including fuel and toll charges, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our customer support team is available round the clock to assist with cab bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Ride Options",
    "WhyChoosedescription": "Choose from local rides, hourly hires, airport transfers, and outstation cab packages based on your travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for cab service in Maval."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services in Maval?',
    answer: 'Yes, Sanavi Travels offers dependable cab services in Maval for local and outstation travel.'
  },
  {
    question: 'How can I book a cab in Maval?',
    answer: 'You can easily book a cab through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cab services are available in Maval?',
    answer: 'Sanavi Travels offers local rides, airport transfers, hourly hires, and outstation cab services in Maval.'
  },
  {
    question: 'Are the drivers experienced with routes in Maval?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Maval area and nearby routes.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup and drop-off locations anywhere in Maval.'
  },
  {
    question: 'Is the cab service in Maval available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services in Maval to suit your travel schedule.'
  },
  {
    question: 'Are the cabs sanitized before every trip?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized to ensure a safe and hygienic travel experience.'
  },
  {
    question: 'What payment options are available for cab services?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for cab bookings.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your journey in Maval.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Amit Shinde',
    feedback: 'Booked a cab in Maval with Sanavi Travels—excellent service, clean vehicle, and friendly driver.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Sneha Kulkarni',
    feedback: 'Great cab service in Maval with on-time pickup and comfortable ride. Highly recommended!',
    rating: 5
  }
];












































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Cabs Service in Maval - Sanavi Travels",
  "description": "Sanavi Travels provides AC, local, and outstation cab services in Maval for tourist travel, picnic trips, family journeys, corporate travel, and weekend outings. Affordable, reliable, chauffeur-driven cabs with easy online booking.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "40"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Cabs Service in Maval | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels provides AC, local, and outstation cab services in Maval for tourist travel, picnic trips, family journeys, corporate travel, and weekend outings. Affordable, reliable, chauffeur-driven cabs with easy online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/180.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabserviceinmaval;